<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex md12>
        <uploader ref="importador" :maxfilesize="maxfilesize" @reload="reload" />
      </v-flex>
      <v-flex md12>
        <data-table ref="tableFileTransaction" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Uploader from "@/views/filetransaction/validator/Uploader"; /** *******************************/
import DataTable from "@/views/filetransaction/validator/DataTable"; /** *******************************/
import ParametrosAPI from "@/services/generales/parametros"; /** *******************************/

export default {
  name: "FileTransaction"
  , components: {
    DataTable
    , Uploader
  }
  , data() {
    return {
      maxfilesize: 0
      , view: { title: this.$t("view.filetransaction.validator.title") }
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.getMaxFileSize();
  }
  , methods: {
    async getMaxFileSize() {
      const response = await ParametrosAPI.get({ clave: 1 });
      this.maxfilesize = response == null || response.data.results.parametros.maxFileSize == null ? 0 : response.data.results.parametros.maxFileSize;
    }
    , reload() {
      this.$refs.tableFileTransaction.refreshData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/filetransaction/validator/Validator.vue